<template>
  <ErrorBoundary>
    <component
      :is="blocksMap[componentType as keyof typeof blocksMap]"
      :content="content"
      @open-contact-form="(plan: any) => emit('openContactForm', plan)"
      @open-case-study-form="emit('openCaseStudyForm')"
    ></component>
  </ErrorBoundary>
</template>

<script setup lang="ts">
import { blocksMap } from './blocksMap'

defineProps<{
  content: any
  componentType: string
}>()

const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])
</script>
